import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Shield, ShieldCheck, Lock, FileCheck2, Mail, ArrowLeft, Check, ScrollText, Database } from "lucide-react";
import FoxLogo from "@/components/FoxLogo";

export default function Compliance() {
  const { t } = useTranslation();
  const sections = [
    { key: "gdpr", icon: Shield, items: 5 },
    { key: "tulps", icon: ShieldCheck, items: 3 },
    { key: "tax", icon: FileCheck2, items: 4 },
    { key: "security", icon: Lock, items: 5 },
    { key: "fiscal", icon: ScrollText, items: 3 },
  ];
  return (
    <div className="bg-slate-50 text-stone-900 min-h-screen">
      <header className="bg-white border-b border-stone-200">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="font-serif text-xl tracking-tight inline-flex items-center gap-2">
            <FoxLogo size={28} />Xenia<span className="text-blue-700">.</span>
          </Link>
          <Link to="/" className="text-sm text-stone-700 hover:text-blue-700 inline-flex items-center gap-1">
            <ArrowLeft className="w-4 h-4" /> {t("compliance_page.back")}
          </Link>
        </div>
      </header>

      <section className="py-16 bg-warm-sage border-b border-sage-200">
        <div className="max-w-5xl mx-auto px-6">
          <p className="text-xs tracked text-sage-dark mb-3">CONFORMITÀ</p>
          <h1 className="font-serif text-4xl lg:text-5xl tracking-tight mb-4">{t("compliance_page.title")}</h1>
          <p className="text-stone-700 text-lg max-w-2xl">{t("compliance_page.subtitle")}</p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-5xl mx-auto px-6">
          <div className="bg-white border-2 border-blue-200 p-8 rounded-sm mb-12">
            <h2 className="font-serif text-2xl tracking-tight mb-2 inline-flex items-center gap-2">
              <Database className="w-5 h-5 text-blue-700" /> {t("compliance_page.intro_title")}
            </h2>
            <p className="text-stone-700">{t("compliance_page.intro_text")}</p>
          </div>

          <div className="space-y-10">
            {sections.map(({ key, icon: Icon, items }) => (
              <article key={key} data-testid={`comp-page-${key}`}>
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-12 h-12 flex-shrink-0 bg-sage-100 border-2 border-sage-200 rounded-sm flex items-center justify-center">
                    <Icon className="w-6 h-6 text-sage-dark" strokeWidth={1.5} />
                  </div>
                  <div className="flex-1">
                    <h2 className="font-serif text-3xl tracking-tight">{t(`compliance_page.section_${key}_title`)}</h2>
                    <p className="text-stone-700 mt-2">{t(`compliance_page.section_${key}_desc`)}</p>
                  </div>
                </div>
                <ul className="ml-16 space-y-2">
                  {Array.from({ length: items }).map((_, i) => (
                    <li key={`${key}-li-${i}`} className="flex items-start gap-2 text-stone-800">
                      <Check className="w-4 h-4 text-sage-dark flex-shrink-0 mt-1" strokeWidth={2.5} />
                      <span>{t(`compliance_page.section_${key}_li_${i + 1}`)}</span>
                    </li>
                  ))}
                </ul>
              </article>
            ))}
          </div>

          <div className="mt-16 bg-blue-700 text-white p-8 rounded-sm">
            <h3 className="font-serif text-2xl tracking-tight mb-2">{t("compliance_page.contact_title")}</h3>
            <p className="text-blue-50">
              {t("compliance_page.contact_text")}
              <a href={`mailto:${t("compliance_page.contact_email")}`} className="underline underline-offset-2 inline-flex items-center gap-1.5 ml-1">
                <Mail className="w-4 h-4" />{t("compliance_page.contact_email")}
              </a>
            </p>
          </div>

          <p className="text-xs text-stone-500 mt-10 text-center">{t("compliance_page.footer_note")}</p>

          <div className="text-center mt-8">
            <Link to="/privacy" className="text-sm text-blue-700 hover:underline mr-4">Informativa Privacy</Link>
            <Link to="/cookie-policy" className="text-sm text-blue-700 hover:underline">Cookie Policy</Link>
          </div>
        </div>
      </section>

      <footer className="border-t border-stone-200 py-8 text-sm text-stone-500 text-center bg-slate-50">
        © {new Date().getFullYear()} Xenia · The Global Guest Registry
      </footer>
    </div>
  );
}
